export const subjectAbility = {
  General: 'General', // general ability, everyone can access
  Setting: 'Setting', // general ability, everyone can access
  Dashboard: 'Dashboard',
  Md: 'Md',
  MdCoa: 'MdCoa',
  MdCashbank: 'MdCashbank',
  MdCOAMainGroupActivity: 'MdCOAMainGroupActivity',
  MdCOAMainActivity: 'MdCOAMainActivity',
  MdCOAActivity: 'MdCOAActivity',
  MdElementMainGroupActivity: 'MdElementMainGroupActivity',
  MdElementMainActivity: 'MdElementMainActivity',
  MdElementActivity: 'MdElementActivity',
  MdContact: 'MdContact',
  MdEmployee: 'MdEmployee',
  MdUser: 'MdUser',
  MdUnit: 'MdUnit',
  MdWorkUnit: 'MdWorkUnit',
  MdProduct: 'MdProduct',
  MdProductBrand: 'MdProductBrand',
  MdProductCategory: 'MdProductCategory',
  MdProductSubCategory: 'MdProductSubCategory',
  MdPrefix: 'MdPrefix',
  Seaport: 'Seaport',
  Airport: 'Airport',
  Tx: 'Tx',
  TxCashbank: 'TxCashbank',
  TxCashbankRequest: 'TxCashbankRequest',
  TxCashbankAddIn: 'TxCashbankAddIn',
  TxCashbankAddOut: 'TxCashbankAddOut',
  TxCashbankAddTransfer: 'TxCashbankAddTransfer',
  TxJournal: 'TxJournal',
  TxDraftJournal: 'TxDraftJournal',
  TxCashAdvanceRequest: 'TxCashAdvanceRequest',
  TxCashAdvance: 'TxCashAdvance',
  TxSalesInvoice: 'TxSalesInvoice',
  TxSalesPayment: 'TxSalesPayment',
  TxPurchaseRequest: 'TxPurchaseRequest',
  TxPurchaseRequestOutstanding: 'TxPurchaseRequestOutstanding',
  TxPurchaseRequestAssignVendor: 'TxPurchaseRequestAssignVendor',
  TxPurchaseRequestAssignPrice: 'TxPurchaseRequestAssignPrice',
  TxPurchaseRequestChooseVendor: 'TxPurchaseRequestChooseVendor',
  TxPurchaseRequestPaymentAdvance: 'TxPurchaseRequestPaymentAdvance',
  TxPurchaseOrder: 'TxPurchaseOrder',
  TxApPosting: 'TxApPosting',
  TxApCashAdvance: 'TxApCashAdvance',
  TxPurchaseInvoice: 'TxPurchaseInvoice',
  TxPurchasePaymentVoucher: 'TxPurchasePaymentVoucher',
  TxPurchasePayment: 'TxPurchasePayment',
  TxGoodsRecipient: 'TxGoodsRecipient',
  TxFormPaymentAdvance: 'TxFormPaymentAdvance',
  TxFormPaymentVendor: 'TxFormPaymentVendor',
  TxFormPayemntAgent: 'TxFormPayemntAgent',
  TxClosing: 'TxClosing',
  TxChBacc: 'TxChBacc',
  TxBacc: 'TxBacc',
  TxBudgeting: 'TxBudgeting',
  Report: 'Report',
  ReportLedger: 'ReportLedger',
  ReportCashAdvance: 'ReportCashAdvance',
  ReportCashAdvanceDetail: 'ReportCashAdvanceDetail',
  ReportSalesInvoice: 'ReportSalesInvoice',
  ReportCashBank: 'ReportCashBank',
  ReportPurchaseAging: 'ReportPurchaseAging',
  ReportPurchaseAgingDetail: 'ReportPurchaseAgingDetail',
  ReportPurchaseInvoice: 'ReportPurchaseInvoice',
  ReportPurchaseInvoiceDetail: 'ReportPurchaseInvoiceDetail',
  ReportTrialBalance: 'ReportTrialBalance',
  ReportWorkSheet: 'ReportWorkSheet',
  ReportPayment: 'ReportPayment',
  ReportProfitLoss: 'ReportProfitLoss',
  ReportJournal: 'ReportJournal',
  BaccTransaction: 'BaccTransaction'
}
